<template>
  <v-app class="app">
    <app-drawer class="app--drawer" ref="drawer" />
    <v-main>
      <div class="page-wrapper">
        <router-view />
      </div>
    </v-main>
    <app-fab />
  </v-app>
</template>

<script>
import AppDrawer from '@/components/AppDrawer.vue';
import AppFab from '@/components/AppFab.vue';

export default {
  name: 'LayoutDefault',
  components: {
    AppDrawer,
    AppFab,
  },

  data() {
    return {
      showDrawer: true
    };
  },
};
</script>

<style lang="sass" scoped>
.page-wrapper
  min-height: 100vh
</style>
